module.exports = __webpack_public_path__ + "img/icon-pdf.d74a9f95.svg";